import { render, staticRenderFns } from "./ProdutosVendidos.vue?vue&type=template&id=5521380c&scoped=true"
import script from "./ProdutosVendidos.vue?vue&type=script&lang=js"
export * from "./ProdutosVendidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5521380c",
  null
  
)

export default component.exports